import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePromoterAuth } from '../../contexts/PromoterAuthContext';
import Layout from '../../components/shared/Layout/Layout';
import Button from '../../components/shared/Button/Button';
import { clearSessionNotice, peekSessionNotice } from '../../utils/sessionExpiry';
import {
  AuthContainer,
  AuthCard,
  AuthTitle,
  AuthSubtitle,
  AuthFooter,
  FormGroup,
  FormLabel,
  FormInput,
  ErrorMessage,
} from '../../components/shared/Form/Form.styles';

const PromoterLogin = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const { login, isAuthenticated, loading, sessionNotice } = usePromoterAuth();
  const navigate = useNavigate();

  // Aviso del JWT vencido (lo deja utils/sessionExpiry antes de redirigir aquí).
  const [expiredNotice] = useState(() => peekSessionNotice('promoter'));
  useEffect(() => { clearSessionNotice('promoter'); }, []);

  // Si ya hay una sesión de promotor válida, directo a su panel.
  useEffect(() => {
    if (!loading && isAuthenticated && !submitting) navigate('/promotor', { replace: true });
  }, [loading, isAuthenticated, submitting, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    const result = await login(formData.email.trim(), formData.password);
    if (result.success) {
      // Aprobado, pendiente, rechazado o suspendido: el panel decide qué mostrar según su estado.
      navigate('/promotor', { replace: true });
    } else {
      setError(result.error || 'No se pudo iniciar sesión.');
      setSubmitting(false);
    }
  };

  const notice = error || sessionNotice || expiredNotice;

  return (
    <Layout headerType="promoter">
      <AuthContainer>
        <AuthCard>
          <AuthTitle>Acceso de promotores</AuthTitle>
          <AuthSubtitle>Entra para ver tus empresas, tus enlaces, tus ventas y tus cortes.</AuthSubtitle>

          {notice && <ErrorMessage role="alert">{notice}</ErrorMessage>}

          <form onSubmit={handleSubmit}>
            <FormGroup>
              <FormLabel htmlFor="pl-email">Email</FormLabel>
              <FormInput
                id="pl-email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="tu@email.com"
                autoComplete="username"
                required
              />
            </FormGroup>
            <FormGroup>
              <FormLabel htmlFor="pl-password">Contraseña</FormLabel>
              <FormInput
                id="pl-password"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Tu contraseña"
                autoComplete="current-password"
                required
              />
            </FormGroup>

            <Button type="submit" fullWidth disabled={submitting}>
              {submitting ? 'Iniciando sesión...' : 'Entrar'}
            </Button>
          </form>

          <AuthFooter>
            <p>¿Aún no eres promotor? <Link to="/promotor/register">Crea tu cuenta</Link></p>
            <p>¿Eres una empresa? <Link to="/empresa/login">Entra al portal de empresa</Link> y abre «Vender como promotor».</p>
          </AuthFooter>
        </AuthCard>
      </AuthContainer>
    </Layout>
  );
};

export default PromoterLogin;
